'use client';

import React, { memo, useMemo, useRef, useState, useEffect, JSX } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** id */
  id?: string;
  /** className */
  className?: string;
  /** type */
  type?: 'type1' | 'type2' | 'type3';
  /** name */
  name?: string;
  /** value */
  value?: string;
  /** disabled */
  disabled?: boolean;
  /** checked */
  checked?: boolean;
  /** tooltip */
  tooltip?: React.JSX.Element;
  /** label */
  label?: React.ReactNode;
  /** children */
  children?: React.ReactNode;
  /** onChange */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Radio = ({
  id,
  className,
  type = 'type1',
  name = '',
  value = '',
  disabled = false,
  checked = false,
  label,
  tooltip,
  children,
  onChange,
}: IProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const [chk, setChk] = useState(checked);

  // 초기화
  useEffect(() => {
    setChk(checked);
  }, [checked, label]);

  const param = {
    htmlFor: id || undefined,
    className: useMemo(
      () =>
        classNameBind(['radio', disabled ? 'disabled' : '', className || '']),
      [disabled, className]
    ),
  };

  const paramInp: any = {
    id: id || undefined,
    name: name || undefined,
    value,
    type: 'radio',
    disabled,
    checked: chk,
    ref,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      if (checked === undefined) {
        setChk(!chk);
      } /* else {
        setChk(e.target.checked);
      } */
      if (onChange) {
        onChange(e);
      }
    },
  };

  // ITEM RENDERER : getInpRender
  const getInpRender = () => (
    <>
      <S.Input {...paramInp} />
      {type === 'type1' && <S.ChkInner className="chk-inner chk-inner1" />}
      {type === 'type2' && <S.ChkInner2 className="chk-inner chk-inner2" />}
      {type === 'type3' && <S.ChkInner3 className="chk-inner chk-inner3" />}
      {(children || label) && (
        <S.Label className="label">
          {children || label}
          {tooltip}
        </S.Label>
      )}
    </>
  );

  return <S.Box {...param}>{getInpRender()}</S.Box>;
};

export default memo(Radio);
